import { EventTypes } from 'redux-segment';

import { CHANGE_PLACEHOLDER_POSITION } from 'actions/scheduler/feChangeSchedulerPlaceholder.types';
import withOptions from 'utils/functions/withOptions.util';

const feChangeSchedulerPlaceholder = withOptions(({ stylistId, time: startTime }) => ({
  type: CHANGE_PLACEHOLDER_POSITION,
  stylistId: stylistId || 0,
  startTime,
  meta: { analytics: EventTypes.track },
}));

export default feChangeSchedulerPlaceholder;
